import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import DeleteModal from 'pages/parts/DeleteModal'

import { httpOk, GET, DELETE } from "helpers/api"
import { formatMoney, formatDate } from 'helpers/helpers'

function Preview() {
	const { t } = useTranslation()
	const { id } = useParams()
	const navigate = useNavigate()

	const [data, setData] = useState({})
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0, index: 0 })

	async function deleteItem() {
		const response = await DELETE(`/documents-in-element/${deleteModalParams.id}`, {}, { loader: true })
		if (httpOk(response)) {
			getData()
			setModalDelete(false)
		}
	}

	async function getData() {
		const response = await GET(`/documents-in/${id}`, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="d-flex text-truncate">
					<h4 className="vertical-center">
						{t('good_reception')}
					</h4>
					<div className="vertical-center mt-1">
						<i className="uil uil-angle-double-right fz-20"></i>
					</div>
					<div className="vertical-center mt-1">
						<h6>{t('preview')}</h6>
					</div>
				</div>
			</div>

			<div className="card mb-3">
				<div className="card-body">
					<h4 className="fw-600">{t('document_from')} {formatDate(data.created_at, "dd.MM.yyyy HH:mm")}</h4>
					<div className="flex-column preview-info">
						<div className="d-flex gap-2">
							<div className="fw-600">{t('supplier')}:</div>
							<div>{data.supplier_name}</div>
						</div>
						<div className="d-flex gap-2">
							<div className="fw-600">{t('document')}:</div>
							<div>{data.document_number}</div>
						</div>
						<div className="d-flex gap-2">
							<div className="fw-600">{t('note')}:</div>
							<div>{data.note}</div>
						</div>
					</div>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}>{t('name2')}</th>
									<th style={{ 'width': '5%' }}>{t('id')}</th>
									<th style={{ 'width': '5%' }} className="text-end">{t('ton')}</th>
									<th style={{ 'width': '5%' }} className="text-end">{t('price')}</th>
									<th style={{ 'width': '5%' }} className="text-end">{t('expense')}</th>
									<th style={{ 'width': '5%' }}>{t('packaging')}</th>
									<th style={{ 'width': '5%' }} className="text-end">{t('quantity')}</th>
									<th style={{ 'width': '5%' }} className="text-end td-ellipsis">{t('supplier_price')}</th>
									<th style={{ 'width': '5%' }} className="text-end">{t('price')}</th>
									<th style={{ 'width': '5%' }} className="text-end">{t('wholesale_price')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('sale_price')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('fact')}</th>
									<th style={{ 'width': '10%' }} className="text-start">{t('unit')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('amount')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.items?.map((item, index) => (
									<tr key={index}>
										<td className="text-center" title={item.id}>
											{index + 1}
										</td>
										<td title={item.product_id}>{item.name}</td>
										<td title={item.product_id}>{item.element_id}</td>
										<td className="text-end">{item.original_quantity}</td>
										<td className="text-end">{item.original_price}</td>
										<td className="text-end">{item.expense}</td>
										<td>{item.packaging_name}</td>
										<td className="text-end">{formatMoney(item.packaging_quantity)}</td>
										<td className="text-end">{formatMoney(item.supplier_price, 2)}</td>
										<td className="text-end">{formatMoney(item.price, 2)}</td>
										<td className="text-end">{formatMoney(item.wholesale_price, 2)}</td>
										<td className="text-end">{formatMoney(item.sale_price, 2)}</td>
										<td className="text-end">{item.quantity}</td>
										<td className="text-start">{item.unit_name}</td>
										<td className="text-end">{formatMoney(item.supplier_price * item.quantity, 2)}</td>
										<td>
											<div className="d-flex justify-content-end d-none">
												{item.status === -1 &&
													<span className="text-danger">{t('deleted')}</span>
												}
												{item.deleatable &&
													<div className="table-action-button table-action-danger-button"
														onClick={() => {
															setDeleteModalParams({ id: item.id, index: index });
															setModalDelete(true)
														}}>
														<i className="uil uil-times"></i>
													</div>
												}
											</div>
										</td>
									</tr>
								))}
								<tr>
									<td></td>
									<td><b>{t('total')}</b></td>
									<td></td>
									<td className="text-end text-nowrap">
										<b>{data?.overall?.overall_original_quantity > 0 && formatMoney(data?.overall?.overall_original_quantity, 2)}</b>
									</td>
									<td></td>
									<td></td>
									<td></td>
									<td className="text-end text-nowrap">
										<b>{formatMoney(data?.overall?.overall_quantity, 2)}</b>
									</td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td className="text-end text-nowrap">
										<b>{formatMoney(data?.overall?.overall_amount, 2)}</b>
									</td>
									<td></td>
								</tr>
							</tbody>
						</table>
					</div>

					<div className="d-flex justify-content-end mt-5">
						<button type="button" className="btn btn-warning btn-rounded btn-wide"
							onClick={() => navigate(window.history.length > 1 ? -1 : window.close())}>
							{t('cancel')}
						</button>
					</div>
				</div>
			</div >

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>
		</>
	)
}

export default Preview